import { Buffer } from "buffer/";

async function ConvertToImage(data) {
    let base64String;
    const buf = Buffer.from(data);
    const blob = new Blob([buf],{type: "image/png"});
    const myFile=new File([blob],'image.png', {
        type: blob.type,
    })
    const reader = new FileReader();
    reader.readAsDataURL(myFile);
    // reader.onloadend = function () { 
    // base64String = reader.result; 
    // // console.log('Base64 String - ', base64String);
    // // console.log('Base64 String without Tags- ',  
    // // base64String.substr(base64String.indexOf(', ') + 1)); 
    // //return base64String     
    // console.log(reader)
    // }
    await new Promise(resolve => reader.onload = () => resolve());
    base64String = reader.result
    return base64String
}
export {ConvertToImage}